module.exports = __webpack_public_path__ + "static/overview01-f38acdd8c71d405567c67d9b23d6ba31.jpg";